var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":_vm.color,"d":"M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }